import { useEffect } from 'react'
import { useTheme } from '@/context/ThemeContext'
import Navigation from '@/components/Frontside/Navigation'
import Methodology from '@/components/Frontside/Methodology'
import Footer from '@/components/Frontside/Footer'

function MethodologyPage() {
  const { setTheme } = useTheme()

  useEffect(() => {
    setTheme('light')
  }, [setTheme])

  return (
    <div className="frontside-page bg-background text-foreground">
      <Navigation currentSection="Methodology" searchValue="" onSearchChange={() => {}} />
      <div className="pt-[100px]">
        <Methodology />
      </div>
      <Footer />
    </div>
  )
}

export default MethodologyPage
